<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card>
      <v-card-title>Switch distillery</v-card-title>
      <v-divider/>
      <v-card-text>
          <v-autocomplete v-model="companyId" outlined dense label="Select distillery" class="mt-6"
                          :items="companies" item-text="name" item-value="id"/>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false">Cancel</v-btn>
        <v-btn color="primary" @click="switchCompany">Switch</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ToolsCompanySwitch',
  data() {
    return {
      show: true,
      companyId: '',
    }
  },
  computed: {
    companies() {
      return this.$store.state.companies.filter(company => company.id !== this.$store.state.companyId);
    }
  },

  methods: {
    switchCompany() {
      if (!this.companyId)
        return;
      this.show = false;
      this.$store.commit('setCompanyId', this.companyId);
      this.$router.push({name:'Dashboard'},null,() => {this.$router.go()});
    }
  }
}
</script>